import React, { useCallback } from 'react';
import Contatti from './Contatti';
import ContattiPagamenti from './ContattiPagamenti';
import ComposizioneMail from './ComposizioneMail';
import { useNavigate } from 'react-router-dom';
import ContattiSolleciti from './ContattiSolleciti';
import ContattiPolizze from './ContattiPolizze';

function Pagamenti() {
  const navigate = useNavigate();
  
  // Stati per la gestione dei tab
  const [activeTab, setActiveTab] = React.useState('generali');
  
  // Stati per i dati del componente attivo
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [placeholders, setPlaceholders] = React.useState([]);
  const [destinatariCount, setDestinatariCount] = React.useState(0);
  const [emailCount, setEmailCount] = React.useState(0);

  const [contactsKey, setContactsKey] = React.useState(0);

  // 🔧 COMPOSIZIONE MAIL SEMPRE VISIBILE
  const showComposizioneMail = true;

  const handleSendComplete = () => {
    setSelectedRows([]);
    setDestinatariCount(0);
    setEmailCount(0);
    setPlaceholders([]);
    setContactsKey(k => k + 1);
  };

  // Reset selezioni al cambio tab
  const handleTabChange = useCallback((newTab) => {
    setActiveTab(newTab);
    setSelectedRows([]);
    setPlaceholders([]);
    setDestinatariCount(0);
    setEmailCount(0);
  }, []);

  // Gestore per i dati dal componente attivo - MEMOIZZATO
  const handleDataChange = useCallback(({ selectedRows, destinatariCount, emailCount, placeholders }) => {
    console.log(`Pagamenti [${activeTab}] - onSelectionChange:`, { 
      selectedRowsLength: selectedRows?.length || 0, 
      destinatariCount, 
      emailCount, 
      placeholdersLength: placeholders?.length || 0 
    });
    
    setSelectedRows(selectedRows || []);
    setDestinatariCount(destinatariCount || 0);
    setEmailCount(emailCount || 0);
    setPlaceholders(placeholders || []);
  }, [activeTab]);
  
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div align="left">
              <h1 className="text-warning">
                <i className="fas fa-coins"></i> Gestione Pagamenti
              </h1>
              <p className="text-muted">Invia comunicazioni e promemoria di pagamento agli iscritti ANUTEL ETS</p>
            </div>
            <div>
              <button className="btn btn-outline-warning" onClick={() => navigate('/dashboard')}>
                <i className="fas fa-arrow-left"></i> Torna al Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Navigazione Tab */}
      <div className="row">
        <div className="col-12">            <div className="mb-3">
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'generali' ? 'active' : ''}`}
                  onClick={() => handleTabChange('generali')}
                  type="button"
                >
                  <i className="fas fa-users me-1"></i>
                  Contatti Generali
                  {activeTab === 'generali' && destinatariCount > 0 && (
                    <span className="badge bg-success ms-2">{destinatariCount}</span>
                  )}
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'pagamenti' ? 'active' : ''}`}
                  onClick={() => handleTabChange('pagamenti')}
                  type="button"
                >
                  <i className="fas fa-coins me-1"></i>
                  Pagamenti
                  {activeTab === 'pagamenti' && destinatariCount > 0 && (
                    <span className="badge bg-success ms-2">{destinatariCount}</span>
                  )}
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'solleciti' ? 'active' : ''}`}
                  onClick={() => handleTabChange('solleciti')}
                  type="button"
                >
                  <i className="fas fa-exclamation-triangle me-1"></i>
                  Solleciti
                  {activeTab === 'solleciti' && destinatariCount > 0 && (
                    <span className="badge bg-success ms-2">{destinatariCount}</span>
                  )}
                </button>
              </li>
              <li className="nav-item"> {/* 🔧 NUOVO TAB POLIZZE */}
                <button
                  className={`nav-link ${activeTab === 'polizze' ? 'active' : ''}`}
                  onClick={() => handleTabChange('polizze')}
                  type="button"
                >
                  <i className="fas fa-shield-alt me-1"></i>
                  Polizze
                  {activeTab === 'polizze' && destinatariCount > 0 && (
                    <span className="badge bg-success ms-2">{destinatariCount}</span>
                  )}
                </button>
              </li>
            </ul>

            
            <div className="card-body p-0">
              <div className="tab-content">
                {/* Tab Contatti Generali */}
                {activeTab === 'generali' && (
                  <div className="tab-pane fade show active">
                    <Contatti
                      key={contactsKey}
                      destinatariId={2126}
                      onSelectionChange={handleDataChange}
                    />
                  </div>
                )}

                {/* Tab Pagamenti */}
                {activeTab === 'pagamenti' && (
                  <div className="tab-pane fade show active">
                    <ContattiPagamenti
                      key={contactsKey}
                      onSelectionChange={handleDataChange}
                    />
                  </div>
                )}

                {/* Tab Solleciti - Placeholder */}
                {activeTab === 'solleciti' && (
                  <div className="tab-pane fade show active">
                    <ContattiSolleciti
                      key={contactsKey}
                      onSelectionChange={handleDataChange}
                    />
                  </div>
                )}

                {/* Tab Polizze - NUOVO */}
                {activeTab === 'polizze' && (
                  <React.Fragment>
                    <ContattiPolizze
                      key={contactsKey}
                      onSelectionChange={handleDataChange}
                    />
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Composizione Mail */}
      {showComposizioneMail && (
        <ComposizioneMail
          servizio={'Pagamenti'}
          destinatariCount={destinatariCount}
          emailCount={emailCount}
          placeholders={placeholders.length > 0 ? placeholders : ['{RAGIONESOCIALE}', '{TIPOENTE}', '{COMUNE}', '{SIGLAPROV}', '{REGIONE}', '{SOCIO}']}
          selectedRows={selectedRows}
          onSendComplete={handleSendComplete}
        />
      )}
    </div>
  );
}

export default Pagamenti;